export default function isMobileBuild() {
  return process.env.VUE_APP_MOBILE_BUILD && process.env.VUE_APP_MOBILE_BUILD.toLowerCase() === "true";
}
